import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

let routes = [
    {
        path: '/auth/login',
        component: {template: '<router-view/>'},
        alias: '/auth/login/index',
        children: [
            {
                path: 'password',
                component: () => import('../frontend/modules/auth/views/login/PasswordLoginForm'),
                alias: '/',
            },
            {
                path: 'sms',
                component: () => import('../frontend/modules/auth/views/login/SmsLoginForm'),
            },
        ]
    }
];

let router = new VueRouter({
    mode: 'history',
    routes,
});

export default router;
